export const routeLoadingOneIfLoadingElseZeroVar = '--route-loading-one';
export const routeLoadingDisplayNoneUnlessLoadingVar =
  '--route-loading-display';
